import { createContext } from 'react';

export interface AuthUser {
    /** Display name from the Microsoft account */
    name: string;
    /** User Principal Name — typically the user's email address */
    email: string;
    /** MSAL home account ID — unique per user/tenant combination */
    accountId: string;
}

export interface AuthContextValue {
    isAuthenticated: boolean;
    /** True while MSAL is processing a redirect or acquiring tokens */
    isLoading: boolean;
    user: AuthUser | null;
    signIn: () => void;
    signOut: () => void;
    /**
     * Acquires an access token for the configured API scopes.
     * Uses silent acquisition (from cache/refresh token) first;
     * falls back to an interactive redirect if interaction is required.
     * Never returns a raw token to be stored in app state — use it
     * immediately for a single API request.
     */
    getAccessToken: () => Promise<string>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
